 <!--
   @url: /order/return/:id
   @author: lentoo
   @created 2019/04/02 09:28:05
   @description: 退货单详情
 -->
<template>
  <cc-container class="detail">
    <cc-header-nav :title="refund ? '来源单据详情' : '退货单详情'">
    </cc-header-nav>
    <cc-main>
      <section class="collapse">
        <van-collapse v-model="activeNames" accordion>
          <van-collapse-item name="1">
            <div slot="title" class="collapse-title-box">
              <i class="cc-icon icon-order"></i>
              <p class="collapse-title">
                {{refund ? '来源单据信息' : '退货单详情'}}
              </p>
            </div>
            <p class="collapse-item">
              退货单号：{{detail.return.return_number}}
            </p>
            <p class="collapse-item">
              退货状态：{{detail.return.state_name}}
            </p>
            <p class="collapse-item">
              退款状态：{{detail.return.refund_state | getRefundState}}
            </p>
            <p class="collapse-item">
              退货原因：{{detail.return.reason}}
            </p>
            <p class="collapse-item">
              退货说明：{{detail.return.message}}
            </p>
            <p class="collapse-item remark" v-if="!refund">
              备注：此退货单为商城退货申请单，单据金额和状态仅供参考，实际退货金额和进度请联系相应的业务员查实，最终以我司出具的纸质退货单为准。
            </p>
            <p class="collapse-item">
              创建时间：{{detail.return.created_time}}
            </p>
            <p class="collapse-item" v-if="detail.return.state == '5'">
              作废原因：{{detail.return.remarks}}
            </p>
            <p class="collapse-item" v-if="detail.return.state == '6'">
              验收不通过原因：{{detail.return.remarks}}
            </p>
          </van-collapse-item>

          <van-collapse-item title="配送信息" name="2">
            <div slot="title" class="collapse-title-box">
              <i class="cc-icon icon-position"></i>
              <p class="collapse-title">
                配送信息
              </p>
            </div>
            <p class="collapse-item">
              联系人：{{detail.order.contacter}}
            </p>
            <p class="collapse-item">
              联系电话：{{detail.member.mobile}}
            </p>
            <p class="collapse-item">
              收货单位：{{detail.order.customer_name}}
            </p>
            <p class="collapse-item">
              收货地址：{{detail.order.address}}
            </p>
          </van-collapse-item>
        </van-collapse>
      </section>
      <cc-card>
        <product-list quantity-text="退货数量：" :list="detail.goods.putongspecial" :checkbox="false" >
          <!-- <product-item
            v-for="item in detail.goods.putongspecial"
            :key="item.product_id"
            :item.sync="item"
          ></product-item> -->
        </product-list>
      </cc-card>

      <section class="summary-box">
        <div>
          <p>
            本单总合计：<span class="price">￥{{detail.return.order_amount}}</span>
          </p>
        </div>
        <div>
          <van-button
            style="background: #1BB0D9;border-color: #1BB0D9;"
            size="small"
            type="primary"
            v-if="detail.return.state === '0'"
            @click="cancel"
          >取消退货申请</van-button>
        </div>
      </section>
    </cc-main>
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
  </cc-container>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { Collapse, CollapseItem, Lazyload, Button, Dialog } from 'vant'
import { types } from '../../../../store/modules/order'
import ProductList from '../components/product-list'
import { ResultCode } from '@/const/ResultCode'
Vue.use(Collapse).use(CollapseItem).use(Lazyload).use(Button).use(Dialog)
export default {
  name: 'return-detail',
  components: {
    ProductList
  },
  data () {
    return {
      activeNames: '1',
      detail: {
        goods: {},
        member: {},
        order: {},
        return: {}
      },
      refund: this.$route.query.refund
    }
  },
  filters: {
    /**
     * @description 获取退货单状态
     */
    getReturnState (type) {
      var state = {
        0: '待审核',
        1: '已取消',
        2: '待退货',
        3: '待入库',
        4: '已完成',
        5: '已作废'
      }
      return state[type]
    },
    /**
     * @description 获取退款状态
     */
    getRefundState (type) {
      var state = {
        0: '未退款',
        1: '部分退款',
        2: '退款完成'
      }
      return state[type]
    }
  },
  computed: {
    ...mapGetters(['getReturnDetail', 'offReturn'])
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions([types.GET_RETURN_DETAIL, types.OFF_RETURN]),

    async loadData () {
      await this.GET_RETURN_DETAIL({
        return_id: this.$route.params.id
      })
      if (this.getReturnDetail.status === ResultCode.SUCCESS) {
        this.detail = this.getReturnDetail.data
      }
    },
    /**
     * @description 取消退货申请
     */
    cancel () {
      Dialog.confirm({
        title: '提示',
        message: '确认取消退货申请吗？'
      }).then(async success => {
        await this.OFF_RETURN({
          id: this.detail.return.id
        })
        this.$tips(this.offReturn, {
          tip: true,
          duration: 1500
        }, res => {
          setTimeout(() => {
            this.$router.replace({
              path: '/order/return',
              query: {
                // 刷新
                r: 1
              }
            })
          }, 2000)
        })
      }).catch(calcel => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/var.scss';
@import '~styles/mixins.scss';
.detail {
  .collapse {
    box-shadow: $box-shadow-base;
    .collapse-title-box {
      @include flex(row);
      align-items: center;
      .collapse-title {
        padding-left: 10px;
      }
    }
    .collapse-item {
      font-size: 12px;
      color: #333;
      margin-left: 40px;
      line-height: 35px;
      box-sizing: border-box;
      border-bottom: 1px solid #EEEEEE;
      &:last-child {
        border-bottom: 0;
      }
    }
    .remark{
      line-height: 20px;
      padding: 10px 0;
      text-align: justify;
      margin-right: 15px;
    }
  }
  .checkbox {
    padding-left: 5px;
  }
  .price {
    color: $price-color;
    font-size: 14px;
    line-height: 1;
  }
  .count {
    color: $heading-color;
    font-size: 12px;
    line-height: 1;
  }
  .summary-box {
    @include flex(row);
    align-items: center;
    box-shadow: $box-shadow-base;
    background: #fff;
    height: 40px;
    // margin-top: 8px;
    margin-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;
    justify-content: space-between;
  }
}
.cc-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
}
.icon-order {
  background: url('~assets/img/sprites/order/order.png');
  background-size: 20px 20px;
}
.icon-position {
  background: url('~assets/img/sprites/order/position.png');
  background-size: 20px 20px;
}
</style>
<style lang="scss">
.detail {
  .van-collapse-item__content {
    padding: 0
  }
}
</style>
